import type { StdioOptions } from 'node:child_process'
/** Interactive runs keep stdin on the terminal so Drizzle rename prompts stay answerable. */
export function resolveDrizzlePushStdio(interactive: boolean | undefined): StdioOptions {
  return interactive ? ['inherit', 'pipe', 'pipe'] : 'pipe'
}
